export default "__VITE_ASSET__Bsw2RtoB__"